import React, { useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { receiveSlidesByCaseId, getReadyForPickupData, receiveSlidesByCaseIdMessage } from '../../actions'
import { RootState } from '../../reducers'
import { SlideHandlingBase } from './SlideHandlingBase'

export function ReceiveSlides({ userId }) {
  const dispatch = useDispatch()
  const { re_slide_success, re_slide_error } = useSelector((state: RootState) => state.receiveSlidesDataResponse)
  const filterData = useSelector((state: RootState) => state.filterPayloadResponse)
  const message = useSelector((state: RootState) => state.errorMessage)
  const { role } = useSelector((state: RootState) => state.userLogin)
  const { data } = useSelector((state: RootState) => state.getReadyForPickupData)

  const handleClose = useCallback(async () => {
    await dispatch(receiveSlidesByCaseIdMessage({ id: '', payload: '' }))
  }, [dispatch])

  const updateDataTable = useCallback(async () => {
    await dispatch(getReadyForPickupData(filterData))
  }, [dispatch, filterData])

  const handleSubmit = useCallback(
    async (val, scannerMode) => {
      await dispatch(receiveSlidesByCaseId({ id: userId, payload: val }))

      if (scannerMode) {
        updateDataTable()
      } else if (re_slide_success !== false && re_slide_error !== true) {
        updateDataTable()
      }
    },
    [dispatch, userId, re_slide_success, re_slide_error, updateDataTable],
  )

  const successMessage = useCallback((caseId) => {
    return `Scanning ${caseId} is successful. You may scan another slide or click Close to exit.`
  }, [])

  return (
    <SlideHandlingBase
      userId={userId}
      title="Receive Slides"
      buttonText="Receive Slides"
      dialogTitle="Receive Slides"
      dialogPrompt="Scan Barcode now, or enter the TRF ID of the case for which you recieved the slides:"
      buttonIcon="save_alt"
      inputLabel="Barcode TRF ID (5 characters only)"
      maxCaseIdLength={5}
      onSubmit={handleSubmit}
      onClose={handleClose}
      successMessage={successMessage}
      errorMessage={message}
      isSuccess={re_slide_success}
      isError={re_slide_error}
      buttonClassName="receiveSlidesButton"
    />
  )
}
